import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { ToggleValue } from 'components/Admin/Shared/Toggle'

type InitialState = {
  yearsAffiliatedVisibility?: ToggleValue
  coachCredentialsVisibility?: ToggleValue
}

const initialState: InitialState = {
  yearsAffiliatedVisibility: null,
  coachCredentialsVisibility: null,
}

export const highlightsSlice = createSlice({
  name: 'highlights',
  initialState: initialState,
  reducers: {
    updateHighlightVisibility: (
      state,
      action: PayloadAction<{
        yearsAffiliated?: ToggleValue
        coachCredentials?: ToggleValue
      }>,
    ) => {
      if (action.payload.yearsAffiliated != null) {
        state.yearsAffiliatedVisibility = action.payload.yearsAffiliated
      }

      if (action.payload.coachCredentials != null) {
        state.coachCredentialsVisibility = action.payload.coachCredentials
      }

      return state
    },
  },
})

export default highlightsSlice.reducer

export const { updateHighlightVisibility } = highlightsSlice.actions
